var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from './styles';
import { registerCustomElement } from '../utils/registerCustomElement';
import { classMap } from 'lit/directives/class-map.js';
let Theme = class Theme extends LitElement {
    constructor() {
        super(...arguments);
        this.themeMode = 'dark';
        // setting this property as a class so that other grain components can access it and we don't have to check in each component
        this.isTouchDevice = navigator.maxTouchPoints > 0;
    }
    updated(changedProperties) {
        if (changedProperties.has('themeMode')) {
            this.requestUpdate();
        }
    }
    render() {
        const themeClasses = classMap({
            'grain-theme': true,
            'grain-theme--light': this.themeMode === 'light',
            'grain-theme--dark': this.themeMode === 'dark',
            'grain-theme--all': this.themeMode === 'all',
            'touch-device': this.isTouchDevice,
        });
        return html `
      <div class=${themeClasses}>
        <slot></slot>
      </div>
    `;
    }
};
Theme.styles = styles;
__decorate([
    property({ type: String })
], Theme.prototype, "themeMode", void 0);
__decorate([
    property({ type: Boolean })
], Theme.prototype, "isTouchDevice", void 0);
Theme = __decorate([
    registerCustomElement('grain-theme')
], Theme);
export { Theme };
